import { makeStyles } from '@mui/styles';
import { ApplicationMuiTheme } from '@tassat/payments-themes/dist/types/theme';

export default makeStyles((theme: ApplicationMuiTheme) => ({
    root: {
        padding: '0',
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary || '#fff',
        fontSize: '.8rem',
        textTransform: 'none' as 'none',
        border: `1px solid ${theme?.app?.applicationColors.enumColors.offWhite || '#e2e2e2'}`,
        borderRadius: '20px',
        '&:hover': { backgroundColor: theme?.app?.clientTheme.colors.buttons.primaryHover || '#BEC6D4' },
        '&:disabled': { backgroundColor: theme?.app?.applicationColors.enumColors.greyLighter || '#cfcfcf' }
    },
    icon: {
        width: '48px',
        height: '24px'
    },
    actionInProgressIcon: { color: theme?.app?.clientTheme.colors.primaryColor || '#375073' },
    active: { backgroundColor: theme?.app?.applicationColors.tableRowLabelColor || 'rgb(185, 217, 236)' },
    tooltip: { top: '-10px !important' }
}));